// extracted by mini-css-extract-plugin
module.exports = {"skills":"Skills_skills__RTobf"};